import script from "./RfidPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RfidPage.vue?vue&type=script&setup=true&lang=ts"

import "./RfidPage.vue?vue&type=style&index=0&id=3cd9e3be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd9e3be"]])

export default __exports__